var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchNormal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 14.6663L13.333 13.333M13.9997 7.66634C13.9997 11.1641 11.1641 13.9997 7.66634 13.9997C4.16854 13.9997 1.33301 11.1641 1.33301 7.66634C1.33301 4.16854 4.16854 1.33301 7.66634 1.33301C11.1641 1.33301 13.9997 4.16854 13.9997 7.66634Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchNormal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-normal.80ba6d2bf02696d606a4ee9c160089a5.svg";